var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.5mm",
    height: "8.5mm",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--gray-20)",
    className: "cls-1",
    d: "M10.1,0C4.5,0,0,4.5,0,10.1s4.5,10.1,10.1,10.1,4.5-.8,6.2-2.1l5.5,5.6c.5.5,1.3.5,1.8,0,.5-.5.5-1.3,0-1.8l-5.6-5.5c1.3-1.7,2.1-3.9,2.1-6.2C20.2,4.5,15.7,0,10.1,0ZM10.1,2.5c4.2,0,7.6,3.4,7.6,7.6s-3.4,7.6-7.6,7.6-7.6-3.4-7.6-7.6,3.4-7.6,7.6-7.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSearch);
export default __webpack_public_path__ + "static/media/header-search.1a9d5269741630f46b4cd1142cffbaa6.svg";
export { ForwardRef as ReactComponent };